<template>
  <v-app>
    <header-app v-show="$route.name !== 'login'" />
    <v-main>
      <router-view style="margin-top: 30px" />
    </v-main>
    <footer-app style="margin-top: 50px" v-show="$route.name !== 'login'" />

  </v-app>
</template>

<script>
import HeaderApp from "./components/HeaderApp";
import FooterApp from "./components/FooterApp";
export default {
  name: "App",

  components: {
    HeaderApp,
    FooterApp,
  },

  data: () => ({
    //
  }),
  methods: {

  },
};
</script>
<style>
* {
  font-family: "Source Sans Pro", sans-serif !important;
}
</style>
